import React, { useState } from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { Check as CheckIcon } from '@mui/icons-material';

/**
 * ColorSwatch Component
 * Displays a single color swatch with hex code
 * Clicking copies the hex code to clipboard
 */
const ColorSwatch = ({ color, size = 50, showLabel = true }) => {
  const [copied, setCopied] = useState(false);

  const handleClick = async () => {
    try {
      await navigator.clipboard.writeText(color.hex);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy color:', err);
    }
  };

  const tooltipTitle = copied
    ? 'Copied!'
    : `${color.name}\n${color.hex}\nClick to copy`;

  return (
    <Tooltip title={tooltipTitle} arrow placement="top">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 0.5,
          cursor: 'pointer',
          transition: 'transform 0.2s',
          '&:hover': {
            transform: 'scale(1.05)'
          }
        }}
        onClick={handleClick}
      >
        <Box
          sx={{
            width: size,
            height: size,
            backgroundColor: color.hex,
            borderRadius: 1,
            border: '1px solid rgba(0, 0, 0, 0.1)',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative'
          }}
        >
          {copied && (
            <CheckIcon
              sx={{
                color: 'white',
                filter: 'drop-shadow(0 0 2px rgba(0,0,0,0.5))',
                fontSize: size / 2
              }}
            />
          )}
        </Box>
        {showLabel && (
          <Box sx={{ textAlign: 'center', maxWidth: size + 20 }}>
            <Typography
              variant="caption"
              sx={{
                fontSize: '10px',
                fontWeight: 500,
                display: 'block',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}
            >
              {color.name}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                fontSize: '9px',
                color: 'text.secondary',
                display: 'block'
              }}
            >
              {color.hex}
            </Typography>
          </Box>
        )}
      </Box>
    </Tooltip>
  );
};

export default ColorSwatch;
